import React from 'react';

import { Container } from './Consents.styled';
import { Loader } from 'components/Loader/Loader';
import { Alert } from 'components/v2/Alert/Alert';
import { useInterstitialStatus } from 'hooks/useInterstitialStatus';
import { Navigation } from 'screens/Book/components/Navigation/Navigation';
import { ConsentsTab } from 'screens/InterstitialModal/components/consent/ConsentsTab';

export const ConsentsStep = ({
  onBack,
  onNextStep
}: {
  onBack: () => void;
  onNextStep: () => void;
}) => {
  const { status, loading } = useInterstitialStatus();

  if (loading || !status) return <Loader container />;

  return (
    <Container>
      <Alert
        title="Almost there!"
        message="Please review and accept the required consents to continue booking your appointment"
        type="warning"
      />
      <ConsentsTab status={status} />
      <Navigation
        onBack={onBack}
        step="consents"
        forwardText="Continue"
        forwardDisabled={!status.hasRequiredConsents}
        forwardFunction={onNextStep}
      />
    </Container>
  );
};
